import { useAppSelector } from 'hooks';

import { ICounterofferItem } from 'models';

import {
	acceptCounteroffer,
	getCounteroffers,
	getCounteroffersMore,
	rejectCounteroffer,
} from 'features/secondaryMarket/actions';

import { CounterofferList } from 'componets/containers';

export const ReceivedCounteroffers = () => {
	const { counteroffers, counterofferPager: pager } = useAppSelector(
		(state) => state.secondaryMarket,
	);

	return (
		<CounterofferList
			getRows={getRows}
			pager={pager}
			items={counteroffers}
			getButtons={(item: ICounterofferItem) => [
				{
					type: 'primary',
					text: 'acceptText',
					callback: acceptCounteroffer,
					id: item.counterOffer.id,
					confirmTitle: 'acceptCounterofferText',
					confirmText: 'acceptCounterofferModalText',
				},
				{
					type: 'default',
					text: 'rejectText',
					callback: rejectCounteroffer,
					id: item.counterOffer.id,
					confirmTitle: 'rejectCounterofferText',
					confirmText: 'rejectCounterofferModalText',
				},
			]}
			callback={getCounteroffers}
			callbackMore={getCounteroffersMore}
		/>
	);
};

const getRows = (item: ICounterofferItem) => [
	{
		title: 'initialInvestmentAmountText',
		value: item.sale.investment.remainingPrincipal,
	},
	{
		title: 'yourPriceText',
		value: item.sale.amount,
	},
	{
		title: 'buyerPriceText',
		value: item.counterOffer.amount,
	},
];
